export default __webpack_public_path__ + "static/media/Neophyte's Boots of Consumed Souls.4b10c3be.jpg";